import { render, staticRenderFns } from "./WarehouseTabInventory.vue?vue&type=template&id=f685067a"
import script from "./WarehouseTabInventory.vue?vue&type=script&lang=js"
export * from "./WarehouseTabInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports